import { makeStyles, tokens } from "@fluentui/react-components";

export const useStyles = makeStyles({
  formContainer: {
    position: "relative",
    display: "flex",
    rowGap: "12px",
    flexDirection: "column",
    flexGrow: 1,
    padding: "10px 10px",
    overflow: "hidden",
    backgroundColor: tokens.colorNeutralBackground2,
  },
  textInputArea: {
    maxHeight: "146px",
    minWidth: "100%",
  },
  formActionContainer: {
    display: "flex",
    flexDirection: "row",
    rowGap: "12px",
    columnGap: "12px",
    flexWrap: "nowrap",
    justifyContent: "stretch",
    width: "100%",
    padding: "16px 0",
  },
  divider: {
    paddingTop: "30px",
    paddingBottom: "10px",
  },
});
